import { createFileRoute } from "@tanstack/react-router";
import { PracticeMasterPage, practiceMasterHead } from "@/components/site/PracticeMasterPage";
import { practiceMasterPages } from "@/data/practice-master-pages";

const page = practiceMasterPages[8];
export const Route = createFileRoute("/practice-areas/workers-compensation-lawyer-seo")({
  head: () => practiceMasterHead(page),
  component: () => <PracticeMasterPage page={page} />,
});
